<template>
  <div class="editor">
    <editor-menu-bar :editor="editor" v-slot="{ commands, isActive }">
      <div class="menubar">
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-bold" variant="success"></b-icon>
          </div>
        </button>
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-italic" variant="success"></b-icon>
          </div>
        </button>
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
        >
          <div class="h6 mb-0">
            <b-icon icon="type-underline" variant="success"></b-icon>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.code_block() }"
          @click="commands.code_block"
        >
          <div class="h6 mb-0">
            <div class="h6 mb-0 alter_icon mark3">영작해석</div>
          </div>
        </button>

        <button class="menubar__button" @click="processing('S')">
          <div class="h6 mb-0 alter_icon mark1">S</div>
        </button>

        <button class="menubar__button" @click="processing('V')">
          <div class="h6 mb-0 alter_icon mark1">V</div>
        </button>

        <button class="menubar__button" @click="processing('C')">
          <div class="h6 mb-0 alter_icon mark1">C</div>
        </button>

        <button class="menubar__button" @click="processing('O')">
          <div class="h6 mb-0 alter_icon mark1">O</div>
        </button>

        <button class="menubar__button" @click="processing('IO')">
          <div class="h6 mb-0 alter_icon mark2">IO</div>
        </button>
        <button class="menubar__button" @click="processing('DO')">
          <div class="h6 mb-0 alter_icon mark2">DO</div>
        </button>
        <button class="menubar__button" @click="processing('M')">
          <div class="h6 mb-0 alter_icon mark2">M</div>
        </button>
        <button class="menubar__button" @click="processing('A')">
          <div class="h6 mb-0 alter_icon mark2">A</div>
        </button>

        <button class="menubar__button" @click="processing('전')">
          <div class="h6 mb-0 alter_icon mark2">전</div>
        </button>
        <button class="menubar__button" @click="processing('전목')">
          <div class="h6 mb-0 alter_icon mark2">전목</div>
        </button>
        <button class="menubar__button" @click="processing('K1')">
          <div class="h6 mb-0 alter_icon mark2">()</div>
        </button>

        <button class="menubar__button" @click="processing('K2')">
          <div class="h6 mb-0 alter_icon mark2">[]</div>
        </button>

        <button class="menubar__button" @click="processing('병렬')">
          <div class="h6 mb-0 alter_icon mark2">병렬</div>
        </button>

        <button class="menubar__button" @click="processing('block')">
          <div class="h6 mb-0 alter_icon mark2">BLOCK</div>
        </button>
        <button
          class="menubar__button"
          :class="{ 'is-active': isActive.hlight({ flag: 1 }) }"
          @click="commands.hlight({ flag: 1 })"
        >
          <div class="h6 mb-0 btnhigh">PEN</div>
        </button>

        <button class="menubar__button" @click="commands.horizontal_rule">
          <div class="h6 mb-0">
            <div class="h6 mb-0 btnhigh">LINE</div>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{
            'is-active': isActive.alignnode({ textAlign: 'left' }),
          }"
          @click="commands.alignnode({ textAlign: 'left' })"
        >
          <div class="h6 mb-0">
            <div class="h6 mb-0 btnhigh">AL</div>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{
            'is-active': isActive.alignnode({ textAlign: 'center' }),
          }"
          @click="commands.alignnode({ textAlign: 'center' })"
        >
          <div class="h6 mb-0">
            <div class="h6 mb-0 btnhigh">AC</div>
          </div>
        </button>

        <button
          class="menubar__button"
          :class="{
            'is-active': isActive.alignnode({ textAlign: 'right' }),
          }"
          @click="commands.alignnode({ textAlign: 'right' })"
        >
          <div class="h6 mb-0">
            <div class="h6 mb-0 btnhigh">AR</div>
          </div>
        </button>
      </div>
    </editor-menu-bar>
    <editor-content class="editor__content" :editor="editor" />
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar, EditorMenuBubble } from "tiptap";
import Image from "./Image";
import HLight from "./HLight";
import AlignNode from "./AlignNode";
import {
  Blockquote,
  CodeBlock,
  HardBreak,
  Heading,
  HorizontalRule,
  OrderedList,
  BulletList,
  ListItem,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Strike,
  Underline,
  History,
  Placeholder,
} from "tiptap-extensions";

import CustomButton from "./CustomButton";
import AWS from "aws-sdk";
async function upload(file) {
  AWS.config.update({
    region: "ap-northeast-2",
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: "ap-northeast-2:dc9b0c57-3ee5-47da-9239-931dcf6da667",
    }),
  });

  var s3 = new AWS.S3({
    apiVersion: "2006-03-01",
    params: { Bucket: "com.cedu.csd" },
  });

  let resp = await s3
    .upload({
      Key: file.name,
      ContentType: "image/png",
      Body: file,
      ACL: "public-read",
    })
    .promise();
  console.log(resp);
  return resp.Location;
}

export default {
  props: ["content", "func"],
  components: {
    EditorContent,

    EditorMenuBar,
  },
  computed: {
    q_type() {
      return this.$store.state.questionform.q_type;
    },
  },

  data() {
    return {
      keepInBounds: true,
      newpop: false,
      editor: new Editor({
        autoFocus: true,
        editable: true,
        extensions: [
          new Blockquote(),
          new BulletList(),
          new CodeBlock(),
          new HardBreak(),
          new Heading({ levels: [1, 2, 3] }),
          new HorizontalRule(),
          new ListItem(),
          new OrderedList(),
          new TodoItem(),
          new TodoList(),
          new Bold(),
          new Code(),
          new Italic(),
          new Strike(),
          new Underline(),
          new History(),
          new CustomButton(),
          new Image(null, null, upload),
          new HLight(),
          new AlignNode(),
        ],
        dropCursor: {
          color: "red",
          width: 2,
        },

        content: this.content,
      }),
      editable: false,
    };
  },

  watch: {
    content(to, from) {
      // alert("changed contente");
      this.editor.setContent(to);
    },
  },

  beforeDestroy() {
    this.editor.destroy();
  },
  mounted() {
    let $this = this;

    this.editor.on("update", ({ getHTML }) => {
      $this.$store.commit($this.func, getHTML());
    });

    this.editor.on("setSelection", ({ getHTML }) => {
      alert("sel");
    });
  },

  methods: {
    processing(strt) {
      const { selection, state } = this.editor;
      const { from, to } = selection;
      const text = state.doc.textBetween(from, to, " ");
      this.$emit("processing", text, strt);
    },
    reset() {
      this.editor.setContent("");
    },
  },
};
</script>


<style lang="scss" scoped>
@import "@/styles/_variables.scss";
.editor {
  //   position: relative;
  border: 1px solid $gray200;
  border-radius: 5px;
  max-width: 100vw;

  &__floating-menu {
    position: absolute;
    z-index: 1;
    margin-top: -0.25rem;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.2s, visibility 0.2s;
    &.is-active {
      opacity: 1;
      visibility: visible;
    }
  }
  .rdclass {
    // color: red;
    // border-bottom: 1px solid red;
    background: #ddd;
    border-radius: 4px;
    padding: 6px;
    font-size: 1em;
    font-weight: normal;
    margin-bottom: 1px;
  }
  .menububble {
    background: $color1;
    &__button {
      background-color: $color2;
      //   padding: 0 5px 0 5px;
    }
    .point2 {
      background-color: $color6;
    }
  }
}

.editor__content *.is-empty:nth-child(1)::before,
.editor__content *.is-empty:nth-child(2)::before {
  content: attr(data-empty-text);
  float: left;
  //   color: #c9cdd2;
  color: red;
  pointer-events: none;
  height: 0;
  font-style: italic;
}

.editor__content pre {
  background: #336699;
}

.alter_icon {
  padding: 1px 4px 1px 4px;
  font-size: 0.9em;
}
.mark1 {
  color: $color5;
}
.mark2 {
  color: $color6;
}

.mark3 {
  color: $color3;
}
.btnhigh {
  font-size: 0.8rem;
}
</style>